export const mockServices = [
  {
    id: 1,
    title: "Protective Coatings & Corrosion Prevention",
    description: "Expert coating evaluation and selection for optimal repairs. Advanced protective coatings that prevent corrosion, extend asset life, and reduce maintenance costs.",
    description2: "All products installed and backed by industry leading warranties.",
    icon: "shield",
    imageKey: "protectiveCoatings"
  },
  {
    id: 2,
    title: "Chillers, Condensers, & Cooling Tower Repairs",
    description: "End-to-end commercial HVAC repair and restoration services featuring tubesheet repairs/coating protection, tube brushing, and cooling tower cleaning with media fill replacement to maximize efficiency and extend system life.",
    icon: "wind",
    imageKey: "hvacRepair"
  },
  {
    id: 3,
    title: "Pipe Repairs, Leak Sealing, & Pipe Wrap Applications",
    description: "Planned and emergency pipeline repairs without hot work, designed to meet globally recognized composite repair standards, with optional ISO 24817 and ASME PCC-2 Article 4.1 compliance where required. These solutions restore integrity, prevent leaks, and perform under demanding service conditions.",
    icon: "pipe",
    imageKey: "pipelineRepair"
  },
  {
    id: 4,
    title: "Structural Repair & Reinforcement",
    description: "Engineered epoxy repairs that restore deteriorated concrete, rebuild metal loss to T-min standards, and reinforce composite structures—improving load capacity and extending asset service life.",
    icon: "building",
    imageKey: "structuralRepair"
  },
  {
    id: 5,
    title: "Rotating Equipment & Pump Restoration",
    description: "Restore performance of worn or damaged pumps and rotating equipment by rebuilding critical surfaces, correcting erosion and corrosion damage, and extending equipment service life while minimizing downtime.",
    icon: "wrench",
    imageKey: "equipmentRepair"
  },
  {
    id: 6,
    title: "Industrial Cleaning & Media-Blasting",
    description: "On-site mobile media-blasting and industrial cleaning services performed on-site to remove corrosion, failed coatings, and surface contaminants, creating the required surface profile for high-performance repairs and protective coatings.",
    icon: "droplet",
    imageKey: "industrialCleaning"
  },
  {
    id: 7,
    title: "Cumulative Tank Repairs and Full Restoration",
    description: "Comprehensive repair and restoration of above-ground and below-grade storage tanks, vessels, and containment systems. Services include rebuilding corrosion damage, restoring metal thickness, sealing active leaks, and reinforcing tank components using engineered epoxy systems to extend service life and defer full replacement.",
    icon: "tank",
    imageKey: "tankRepair"
  },
  {
    id: 8,
    title: "Roof Leak Seal and Full Membrane Encapsulation",
    description: "Industrial roof leak repair and waterproofing for metal, concrete, and membrane roofing systems. Leak paths are identified and sealed, penetrations and seams are reinforced, and durable coating systems are installed to restore watertight integrity and protect facilities from ongoing water intrusion.",
    icon: "roof",
    imageKey: "roofRepair"
  },
  {
    id: 9,
    title: "Total Floor Repairs & Safety Striping",
    description: "Industrial floor repair and protective coating systems designed for chemical exposure, heavy traffic, and demanding service environments. Cracks, spalls, and surface deterioration are repaired, followed by installation of high-performance epoxy and resinous flooring systems that improve durability, safety, and long-term performance.",
    icon: "floor",
    imageKey: "floorRepair"
  }
];

export const mockIndustries = [
  {
    id: 1,
    name: "Manufacturing & Heavy Industry",
    description: "Comprehensive solutions for production facilities, processing plants, and heavy industrial operations.",
    icon: "factory",
    imageKey: "manufacturing"
  },
  {
    id: 2,
    name: "Oil & Gas",
    description: "Specialized repairs and coatings for refineries, processing plants, and petrochemical facilities.",
    icon: "fuel",
    imageKey: "oilGas"
  },
  {
    id: 3,
    name: "Power Generation / Energy",
    description: "Reliable solutions for power plants, energy facilities, and critical infrastructure.",
    icon: "zap",
    imageKey: "powerGeneration"
  },
  {
    id: 4,
    name: "Water & Wastewater",
    description: "Corrosion-resistant solutions for water treatment facilities and wastewater management systems.",
    icon: "droplet",
    imageKey: "waterTreatment"
  },
  {
    id: 5,
    name: "Marine & Offshore",
    description: "Durable protective solutions designed for harsh marine and offshore environments.",
    icon: "anchor",
    imageKey: "marine"
  },
  {
    id: 6,
    name: "Commercial & Industrial Facilities",
    description: "Versatile repair and protection solutions for diverse industrial applications.",
    icon: "settings",
    imageKey: "generalIndustrial"
  },
  {
    id: 7,
    name: "Petrochemical",
    description: "Advanced repair and protection solutions for petrochemical processing facilities and chemical plants.",
    icon: "beaker",
    imageKey: "petrochemical"
  },
  {
    id: 8,
    name: "General Industry",
    description: "Flexible repair and coating solutions for a wide range of industrial equipment and facilities.",
    icon: "cog",
    imageKey: "generalIndustry"
  },
  {
    id: 9,
    name: "Wind Power",
    description: "Specialized repair and protection for wind turbines, towers, and renewable energy infrastructure.",
    icon: "wind",
    imageKey: "windPower"
  }
];

export const mockBenefits = [
  {
    id: 1,
    title: "Minimized Downtime",
    description: "Fast-curing solutions and emergency repair capabilities keep your operations running.",
    icon: "timer"
  },
  {
    id: 2,
    title: "No Hot Work Required",
    description: "Cold-applied epoxy solutions eliminate the need for welding, reducing safety risks and permit requirements.",
    icon: "flame"
  },
  {
    id: 3,
    title: "Long-Term Durability",
    description: "Proven track record of lasting repairs that extend asset life and reduce maintenance costs.",
    icon: "award"
  },
  {
    id: 4,
    title: "Expert Technical Support",
    description: "On-site assistance, training, and engineering expertise tailored to your specific needs.",
    icon: "users"
  },
  {
    id: 5,
    title: "Customer Portal Access",
    description: "Track projects in real-time, document case studies, maintain complete repair histories, and access all your project documentation in one secure place.",
    icon: "laptop"
  }
];

export const mockCompanyInfo = {
  name: "BCS",
  tagline: "Industrial Epoxy Solutions That Last",
  description: "BCS provides advanced epoxy repair composites and protective coating systems for industrial equipment, structures, and critical infrastructure. Our solutions reduce downtime, eliminate hot work, and deliver durable, long-term performance in demanding environments.",
  phone: "(949) 371-9948",
  email: "",
  address: ""
};

export const mockTestimonials = [
  {
    id: 1,
    name: "",
    company: "",
    role: "Maintenance Superintendent",
    quote: "These guys came in and saved us thousands of dollars in downtime and replacement costs. They're now our first call.",
    rating: 5
  },
  {
    id: 2,
    name: "",
    company: "",
    role: "Reliability Engineer",
    quote: "BCS goes above and beyond every time they're here. I trust them to do what's right, not just what's easy.",
    rating: 5
  },
  {
    id: 3,
    name: "",
    company: "",
    role: "Rotating Equipment Manager",
    quote: "We had pumps that were basically trash and BCS rebuilt them better than new. It's amazing to see.",
    rating: 5
  },
  {
    id: 4,
    name: "",
    company: "",
    role: "Chief Facilities Engineer",
    quote: "They repaired and coated our chiller, handled cooling tower leaks and fill media replacement, and now they're coating our mechanical room floors. They makes my life easier.",
    rating: 5
  }
];
